<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-card flat class="text-xs-center ma-3" width="100%">
                <v-card-title class=" primary">
                    <span class="card-title-text" style="color: white;">Búsqueda de Poderes</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="validForm" lazy-validation>
                        <v-row>
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Número de escritura:</label>
                                <v-text-field v-model="escritura"
                                              maxlength="6"
                                              outlined
                                              dense
                                              @keypress="filter($event)">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Cliente:</label>
                                <multiselect v-model="busqueda.aseguradora" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor"
                                             track-by="clclave" label="clnombre" placeholder="Seleccionar Cliente"
                                             :options="aseguradoras" :allow-empty="false"
                                            >
                                </multiselect>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Flotillas:</label>
                                <multiselect v-model="busqueda.flotilla" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor"
                                             track-by="flclave" label="flnomcorto" placeholder="Seleccionar Flotilla"
                                             :options="flotillas" :allow-empty="false">
                                </multiselect>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Razón Social:</label>
                                <v-text-field v-model="razonsocial"
                                              maxlength="300"
                                              outlined
                                              dense>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Responsable:</label>
                                <multiselect v-model="busqueda.abogado" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor"
                                             track-by="uslogin" label="usnom" placeholder="Seleccionar un Responsable"
                                             :options="abogados" :allow-empty="false">
                                </multiselect>
                            </v-col>
                            <!--<v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Estado:</label>
                                <multiselect v-model="busqueda.estado" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor"
                                             track-by="esclave" label="esnombre" placeholder="Seleccionar un Estado"
                                             :options="estados" :allow-empty="true">
                                </multiselect>
                            </v-col>-->
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       @click="Buscar()"
                                       color="primary">
                                    Buscar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()" color="default">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Cancelar()" color="error">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                        
                    </v-form>
                </v-card-text>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="verfinanzas" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Resultados</v-expansion-panel-header>
                        <v-expansion-panel-content  v-if="ver">
                            <br />
                            <DataTable :url="url"
                                       :columns="head"
                                       :params="displayInputs"
                                       :formatterActions="formatterActions"
                                       :order="[[0, 'desc']]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import General from "@/services/Operacion/Operacion.service.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                verfinanzas: [0],
                validForm: true,
                showcargando: true,
                rules: {
                    required: value => !!value || 'Campo requerido',
                },
                escritura: '',
                razonsocial: '',
                busqueda: {
                    aseguradora: '',
                    flotilla: '',
                    abogado: '',
                    estado: '',
                },
                aseguradoras: [],
                flotillas: [],
                abogados: [],
                estados: [],
                apiDT: null,
                displayInputs: {},
                url: "Operacion/BusquedaPoder",
                head: [
                    { name: "podclave", data: "podclave", title: "Num de escritura", formatter: [this, "detalleGeneral"], },
                    { name: "podnumcopia", data: "podnumcopia", title: "Num de copia" },
                    { name: "podfhinivig", data: "podfhinivig", title: "Fecha Inicial" },
                    { name: "podfhfinvig", data: "podfhfinvig", title: "Fecha Final" },
                    { name: "podrazonsocial", data: "podrazonsocial", title: "Razón Social" },
                    { name: "responsable", data: "responsable", title: "Responsable" },
                    { name: "vigencia", data: "vigencia", title: "Vigencia", formatter: [this, "detalleVigencia"], },
                ],
                formatterActions: [
                    { click: [this, "BuscarPoder"] },
                ],
                ver: false,
            }
        },
        methods: {
            Cancelar() {
                this.$router.push({ name: 'Menu' });
            },
            async BuscarPoder(params, item, fila) {
                await MetodosGenerales.guardarEnSesionInfoReporte(item, 'poderes');
                this.$router.push({ name: 'DetallePoderes' });
            },
            detalleGeneral(datos) {
                
                return `<button data-action="0" data-params="${datos.podnumescritura}" class="dt-formatterAction ma-1 reporteindice">${datos.podnumescritura}</span></button>`;
               
            },
            detalleVigencia(datos) {
                if (datos.mesesV > 6) {
                    return `<span class="ma-2 v-chip theme--light v-size--default green white--text"><span class="v-chip__content"></span></span>`;
                }
                else if (datos.mesesV > 3 && datos.mesesV <= 6) {
                    return `<span class="ma-2 v-chip theme--light v-size--default yellow white--text"><span class="v-chip__content"></span></span>`;
                }
                else if (datos.mesesV >= 1 && datos.mesesV <= 3) {
                    return `<span class="ma-2 v-chip theme--light v-size--default orange white--text"><span class="v-chip__content"></span></span>`;
                }
                else if (datos.mesesV == 0 && datos.diasV >= 1) {
                    return `<span class="ma-2 v-chip theme--light v-size--default orange white--text"><span class="v-chip__content"></span></span>`;
                }
                else if (datos.mesesV == 0 && datos.diasV <= 0) {
                    return `<span class="ma-2 v-chip theme--light v-size--default red white--text"><span class="v-chip__content"></span></span>`;
                }
                
            },
            Limpiar() {
                this.busqueda.aseguradora = '';
                this.busqueda.flotilla = '';
                this.busqueda.estado = '';
                this.busqueda.abogado = '';
                this.escritura = '';
                this.razonsocial = '';
                this.$refs.form.reset();
                if (this.apiDT != null)
                    this.apiDT.clear().draw();
            },
            reloadTable() {
                
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            async Buscar() {
                let ban = 0;
                //if (this.busqueda.aseguradora != '' && this.busqueda.aseguradora != null)
                //    ban++;
                //if (this.busqueda.flotilla != '' && this.busqueda.flotilla != null)
                //    ban++;
                //if (this.escritura != '' && this.escritura != null)
                //    ban++;
                //if (this.razonsocial != '' && this.razonsocial != null)
                //    ban++;
                //if (this.busqueda.abogado != '' && this.busqueda.abogado != null)
                //    ban++;
                //if (ban >= 2) {
                    this.ver = true;
                    this.displayInputs.clclave = this.busqueda.aseguradora != '' ? this.busqueda.aseguradora.clclave : null;
                    this.displayInputs.flclave = this.busqueda.flotilla != '' ? this.busqueda.flotilla.flclave : null;
                    this.displayInputs.podnumescritura = this.escritura != '' ? this.escritura : null;
                    this.displayInputs.podrazonsocial = this.razonsocial != '' ? this.razonsocial : null;
                    this.displayInputs.responsable = this.busqueda.abogado != '' && this.busqueda.abogado != null ? this.busqueda.abogado.uslogin : null;
                    this.reloadTable();
                //}
                //else {
                //    this.$swal(
                //        "Atención",
                //        "Tiene que agregar al menos 2 filtros para la búsqueda",
                //        "info"
                //    );
                //}
            },
            async ListadoEstado() {
                await General.ListadoEstado(this).then(data => {
                    this.estados = data;
                });
            },
            async ListadoProveedor() {
                await General.ListadoUsuarios(this).then(data => {
                    this.abogados = data;
                });
            },
            async ClientesPoderes() {
                await General.ClientesPoderes(this).then(data => {
                    this.aseguradoras = data;
                });
            },
            async ObtenerFlotilla() {
                let form = new FormData();
                await General.ListadoFlotilla(this).then(data => {
                    this.flotillas = data;
                });
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        mounted() {
            this.ClientesPoderes();
            this.ListadoProveedor();
            this.ObtenerFlotilla();
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '275').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>
<style scoped>
    .title-card-style {
        padding: 1.5px !important;
        max-height: auto;
    }

    .card-title-text {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1em;
        color: white;
    }
</style>